import { Image } from "react-native";

interface LogoProps {
  uri: string;
  height?: number;
  width?: number;
}

function Logo({ uri, height = 100, width = 280 }: LogoProps) {
  return (
    <Image
      source={{ uri }}
      style={{ height, width }}
      resizeMode="contain"
      accessible={true}
      accessibilityRole="image"
      accessibilityLabel="company logo"
      alt="company logo"
      role="img"
    />
  );
}

export default Logo;
